const Popup = ({ isOpen, togglePopup, msg }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[99999] flex items-center justify-center bg-black/50">
      <div className="relative w-[90%] max-w-md rounded-xl bg-white p-6 shadow-2xl">
        <button
          onClick={togglePopup}
          className="absolute right-3 top-2 text-2xl text-gray-500 hover:text-black"
        >
          ×
        </button>

        <h2 className="mb-4 text-2xl font-bold text-cyan-700">
          Nachricht
        </h2>

        <p className="text-gray-700">{msg}</p>

        <button
          onClick={togglePopup}
          className="mt-6 w-full rounded-lg bg-cyan-700 py-2 text-white hover:bg-cyan-800"
        >
          Schließen
        </button>
      </div>
    </div>
  );
};

export default Popup;
